import { inject, Injectable } from '@angular/core';
import { LoggerService } from '../logger.service';

export interface Token {
  access_token: string;
  expires_in?: number;
  expiration_timestamp?: number;
}

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  private logger = inject(LoggerService)

  setToken(token: Token): void {
    this.logger.log('Storing token in local storage', token);
    if (token) {
      localStorage.setItem('token', JSON.stringify(token));
    }
  }

  getToken(): Token | null {
    this.logger.log('Retrieving token from local storage');
    const token = localStorage.getItem('token');
    return token ? JSON.parse(token) : null;
  }

  clear(): void {
    this.logger.log('Clearing token from local storage');
    localStorage.removeItem('token');
  }
}
